import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const EditarCurso = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    codigo: "",
    nome: "",
    nivel: "",
    modalidade: "",
    coordenador_id: ""
  });
  const [disciplinas, setDisciplinas] = useState([]);
  const [disciplinasSelecionadas, setDisciplinasSelecionadas] = useState([]);
  const [coordenadores, setCoordenadores] = useState([]);
  const [parametros, setParametros] = useState({ cor_cabecalho: "#156082" });
  const [carregando, setCarregando] = useState(true);
  const tipoUsuario = localStorage.getItem("tipo");
  const somenteLeitura = tipoUsuario === "coordenador";


  useEffect(() => {
    carregarCurso();
    carregarCoordenadores();
    carregarDisciplinas();
    carregarParametros();
  }, []);

  const carregarCurso = async () => {
    try {
      const cursoRes = await axios.get(`/api/cursos/${id}`);
      const cursoData = cursoRes.data;
      setFormData({
        codigo: cursoData.codigo,
        nome: cursoData.nome,
        nivel: cursoData.nivel,
        modalidade: cursoData.modalidade,
        coordenador_id: cursoData.coordenador_id || ""
      });
      if (cursoData.disciplinas && Array.isArray(cursoData.disciplinas)) {
        setDisciplinasSelecionadas(cursoData.disciplinas.map(d => d.id));
      } else {
        setDisciplinasSelecionadas([]);
      }
      setCarregando(false);
    } catch (error) {
      console.error("Erro ao carregar curso:", error);
      alert("Erro ao carregar os dados do curso.");
      navigate("/cursos");
    }
  };

  const carregarCoordenadores = async () => {
    try {
      const clienteId = localStorage.getItem("cliente_id");
      const res = await axios.get(`/api/usuarios/coordenadores?cliente_id=${clienteId}`);
      setCoordenadores(res.data);
    } catch (error) {
      console.error("Erro ao carregar coordenadores:", error);
    }
  };

  const carregarDisciplinas = async () => {
    try {
      const clienteId = localStorage.getItem("cliente_id");
      const res = await axios.get(`/api/disciplinas?cliente_id=${clienteId}`);
      setDisciplinas(res.data);
    } catch (error) {
      console.error("Erro ao carregar disciplinas:", error);
    }
  };

  const carregarParametros = async () => {
    try {
      const clienteId = localStorage.getItem("cliente_id");
      const response = await axios.get(`/api/parametros_cliente/${clienteId}`);
      const dados = await response.data;
      if (!dados.erro) {
        setParametros(dados);
      }
    } catch (error) {
      console.error("Erro ao carregar parâmetros:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`/api/cursos/${id}`, {
        ...formData,
        disciplinasSelecionadas,
        usuario_id: parseInt(localStorage.getItem("user_id"), 10) // 👈 inclusão do ID do usuário
      });
      alert("Curso atualizado com sucesso.");
      navigate("/cursos");
    } catch (error) {
      console.error("Erro ao atualizar curso:", error);
      alert("Erro ao atualizar o curso.");
    }
  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDisciplinaChange = (disciplinaId) => {
    setDisciplinasSelecionadas((prev) => {
      if (prev.includes(disciplinaId)) {
        return prev.filter((id) => id !== disciplinaId);
      } else {
        return [...prev, disciplinaId];
      }
    });
  };

  if (carregando) return <div>Carregando...</div>;

  return (
    <div className="form-wrapper form-curso">
      <h2 className="form-title">Editar Curso</h2>
      <form onSubmit={handleSubmit}>

        <div className="form-row">
          <div className="form-group" style={{ width: "180px" }}>
            <label>Código</label>
            <input
              type="text"
              name="codigo"
              value={formData.codigo}
              onChange={handleChange}
              required
              disabled={somenteLeitura}
            />
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Nome</label>
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              required
              disabled={somenteLeitura}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group" style={{ width: "220px" }}>
            <label>Nível</label>
            <select
              name="nivel"
              value={formData.nivel}
              onChange={handleChange}
              required
              disabled={somenteLeitura}
            >
              <option value="">Selecione</option>
              <option value="Ensino Médio">Ensino Médio</option>
              <option value="Preparatório">Preparatório</option>
              <option value="Graduação/Pós">Graduação/Pós</option>
              <option value="PJ RH/T&D">PJ RH/T&D</option>
            </select>
          </div>

          <div className="form-group" style={{ width: "220px" }}>
            <label>Modalidade</label>
            <select
              name="modalidade"
              value={formData.modalidade}
              onChange={handleChange}
              required
              disabled={somenteLeitura}

            >
              <option value="">Selecione</option>
              <option value="Presencial">Presencial</option>
              <option value="Híbrido">Híbrido</option>
              <option value="Live">Live</option>
              <option value="EAD">EAD</option>
              <option value="Outros">Outros</option>
            </select>
          </div>

          <div className="form-group" style={{ flex: 1 }}>
            <label>Coordenador</label>
            <select
              name="coordenador_id"
              value={formData.coordenador_id}
              onChange={handleChange}
              disabled={somenteLeitura}
            >
              <option value="">Selecione</option>
              {coordenadores.map((coordenador) => (
                <option key={coordenador.id} value={coordenador.id}>
                  {coordenador.nome_completo}
                </option>
              ))}
            </select>
          </div>
        </div>

        <h3 className="subtitulo">Disciplinas do Curso</h3>

        {disciplinas.length > 0 ? (
          <div style={{ overflowX: "auto", marginTop: "10px" }}>
            <table className="tabela" style={{ fontSize: "0.75rem", marginTop: "10px" }}>
              <thead
                style={{
                  backgroundColor: parametros?.cor_cabecalho || "#156082",
                  color: "white"
                }}
              >
                <tr>
                  <th style={{ width: "15%", textAlign: "left", padding: "10px" }}>Código</th>
                  <th style={{ width: "70%", textAlign: "left", padding: "10px" }}>Nome</th>
                  <th style={{ width: "15%", textAlign: "center", padding: "10px" }}>Selecionar</th>
                </tr>
              </thead>
              <tbody>
                {disciplinas.map((disciplina) => (
                  <tr key={disciplina.id}>
                    <td style={{ padding: "10px" }}>{disciplina.codigo}</td>
                    <td style={{ padding: "10px" }}>{disciplina.nome}</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      <input
                        type="checkbox"
                        checked={disciplinasSelecionadas.includes(disciplina.id)}
                        onChange={() => handleDisciplinaChange(disciplina.id)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p style={{ marginTop: "10px" }}>Nenhuma disciplina disponível.</p>
        )}

        <div className="form-actions">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate("/cursos")}
          >
            Cancelar
          </button>
          <button type="submit" className="btn btn-primary">
            Salvar Alterações
          </button>
        </div>

      </form>
    </div>
  );
};

export default EditarCurso;


